import React, { Component } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Header from './components/Header';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';

class App extends Component {

  state = {
    profile: {
      name: 'Fadli Hidayatullah',
      role: 'Tech Enthusiast',
      bio: 'Was born and Level up at beloved Bengkulu city. Now, studying at Diploma of Software Engineering Telkom University.'
    },
    contactList: {
      email: 'fadlihdytullah@gmail.com',
      github: 'fadlihdytullah',
      githubUrl: 'https://github.com/fadlihdytullah/',
      instagram: 'fadlihdytullah',
      instagramUrl: 'https://www.instagram.com/fadlihdytullah/',
      linkedin: 'Fadli Hidayatullah',
      linkedinUrl: 'https://www.linkedin.com/in/fadli-hidayatullah-519188181/'
    }
  }

  render() {
    const { profile, contactList } = this.state;
    return (
      <div className="App">
        <Navbar />        
        <Header profile={profile} />
        <Portfolio />
        <Contact contactList={contactList} />
      </div>
    );
  }
}

export default App;
